import { makeAutoObservable } from 'mobx';
import {
  defaultPercentage,
  TeamsSortBy,
} from 'pages/iPriseV2/common/enum/TeamUserRoles';

export class RecruiterJobQueueService {
  newPage = 0;
  newRowsPerPage = 50;
  pendingPage = 0;
  pendingRowsPerPage = 50;
  submittedPage = 0;
  submittedRowsPerPage = 50;
  subTab = 0;
  searchTerm = '';
  selectedSort = String(TeamsSortBy.NEWEST_FIRST);
  percentage = defaultPercentage;

  constructor() {
    makeAutoObservable(this);
  }

  setNewPage(page: number) {
    this.newPage = page;
  }

  setNewRowsPerPage(rowsPerPage: number) {
    this.newRowsPerPage = rowsPerPage;
    this.newPage = 0;
  }

  setPendingPage(page: number) {
    this.pendingPage = page;
  }

  setPendingRowsPerPage(rowsPerPage: number) {
    this.pendingRowsPerPage = rowsPerPage;
    this.pendingPage = 0;
  }

  setSubmittedPage(page: number) {
    this.submittedPage = page;
  }

  setSubmittedRowsPerPage(rowsPerPage: number) {
    this.submittedRowsPerPage = rowsPerPage;
    this.submittedPage = 0;
  }

  setSubTab(tab: number) {
    this.subTab = tab;
  }

  setSearchTerm(term: string) {
    this.searchTerm = term;
    this.newPage = 0;
    this.pendingPage = 0;
    this.submittedPage = 0;
  }

  reset() {
    this.newPage = 0;
    this.newRowsPerPage = 50;
    this.pendingPage = 0;
    this.pendingRowsPerPage = 50;
    this.submittedPage = 0;
    this.submittedRowsPerPage = 50;
    this.subTab = 0;
    this.searchTerm = '';
    this.selectedSort = String(TeamsSortBy.NEWEST_FIRST);
    this.percentage = defaultPercentage;
  }

  setSelectedSort(sort: string) {
    this.selectedSort = sort;
  }

  setPercentage(value: string) {
    this.percentage = value;
  }
}

export const recruiterJobQueueService = new RecruiterJobQueueService();
